import React, { useState, useEffect } from 'react';
import DashboardDoctorHeader from "../../components/MainHeader/DashboardDoctorHeader";
import Sidebar from "../../components/Sidebar";
import axios from 'axios';
import { API_BASE_URL } from '../../app_url';
import LoadingPage from "../../components/LoadingPage";
import { useUserContext } from "../../context/UserContext";
import './NotificationsHistory.scss';

const NotificationsHistory = () => {
    const { sidebarDrawerOpen } = useUserContext();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);

    const getHeader = () => {
        let loginInfo = localStorage.getItem("doctolikLoginInfo");
        if (!loginInfo) return {};
        let value = JSON.parse(loginInfo);
        return {
            headers: {
                Authorization: "Bearer " + value?.authorisation?.token,
            },
        };
    };

    const fetchNotifications = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}v1/notifications`, getHeader());
            console.log("Fetched notifications for history:", response.data);
            setNotifications(response.data);
        } catch (error) {
            console.error("Error fetching notifications for history:", error);
        } finally {
            setLoading(false);
        }
    };

    const markAsRead = async (id) => {
        try {
            await axios.post(`${API_BASE_URL}v1/notifications/${id}/read`, {}, getHeader());
            setNotifications(notifications.map(n => n.id === id ? { ...n, is_read: true } : n));
        } catch (error) {
            console.error("Error marking as read:", error);
        }
    };

    useEffect(() => {
        fetchNotifications();
    }, []);

    const getTypeBadgeClass = (type) => {
        const types = {
            'ALERTE': 'badge-danger',
            'INFORMATION': 'badge-info',
            'ANNONCE': 'badge-primary',
            'MISE_A_JOUR': 'badge-success',
            'ADMINISTRATION': 'badge-secondary',
        };
        return types[type] || 'badge-light';
    };

    return (
        <div className="doctormain">
            <Sidebar />
            <div className={`DashboardBody rightSec ${sidebarDrawerOpen ? "drawer_open" : ""}`}>
                <DashboardDoctorHeader />
                <div className="mainDiv">
                    <div className="history-header">
                        <h2>Historique des Notifications</h2>
                    </div>

                    {loading ? (
                        <div className="loading-wrapper" style={{ padding: '50px', textAlign: 'center' }}>
                            <LoadingPage />
                        </div>
                    ) : (
                        <div className="notifications-container">
                            {notifications.length === 0 ? (
                                <div className="no-notifications" style={{ padding: '40px', textAlign: 'center', color: '#999', fontSize: '18px' }}>
                                    Aucune notification trouvée.
                                </div>
                            ) : (
                                <div className="notifications-list-full">
                                    {notifications.map((notif) => (
                                        <div 
                                            key={notif.id} 
                                            className={`notification-card ${!notif.is_read ? 'unread' : ''}`}
                                            onClick={() => !notif.is_read && markAsRead(notif.id)}
                                        >
                                            <div className="card-header">
                                                <span className={`type-badge ${getTypeBadgeClass(notif.type)}`}>{notif.type}</span>
                                                <span className="notif-date">{new Date(notif.created_at).toLocaleString()}</span>
                                            </div>
                                            <div className="card-body">
                                                <h3 className="notif-title">{notif.title}</h3>
                                                <p className="notif-content">{notif.content}</p>
                                            </div>
                                            {!notif.is_read && <div className="unread-dot"></div>}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotificationsHistory;
